import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AdminPanelService} from 'projects/app-misc/src/app/modules/admin-panel/data/admin-panel.service';
import {ItemGroup} from 'projects/app-misc/src/app/modules/admin-panel/data/item-group';
import {Subject, timer} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ConfirmationService} from 'primeng/api';
import {OverlayPanel} from 'primeng/overlaypanel';
import {Table} from 'primeng/table';
import {MiscSnackBarService} from '../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {CategoryEditorDialogComponent} from '../pricing-categories-editor/category-editor-dialog/category-editor-dialog.component';
import {PricingCategory} from '../../../project-calc/data/pricing-category';
import {MatDialog} from '@angular/material/dialog';
import {MiscItemFilesDialogComponent} from './misc-item-files-dialog/misc-item-files-dialog.component';

@Component({
  selector: 'app-item-editor',
  templateUrl: './item-editor.component.html',
  styleUrls: ['./item-editor.component.scss'],
  providers: [ConfirmationService]
})
export class ItemEditorComponent implements OnInit {
  itemGroups: ItemGroup[]

  loadingSpinner = true;

  updateItemsSubj = new Subject<number>()

  @ViewChild('eventHintOP', {static: true})
  eventHintOP: OverlayPanel

  constructor(
    protected dialog: MatDialog,
    protected el: ElementRef,
    protected adminPanelService: AdminPanelService,
    protected confirmationService: ConfirmationService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {
    this.adminPanelService.getGroupItems().subscribe(groups => {
      this.itemGroups = groups
      this.loadingSpinner = false
    })

    this.updateItemsSubj.pipe(debounceTime(500)).subscribe(index => {
      this.itemGroups[index].name = this.itemGroups[index].name.trim()
      this.itemGroups[index].items.forEach(item => {
        item.name = item.name.trim()
      })

      this.adminPanelService.updateGroupItems(this.itemGroups[index]).subscribe(() => {

      })
    })
  }

  addGroup() {
    this.itemGroups.push({
      name: 'New Group',
      items: []
    })

    this.adminPanelService.createGroup(this.itemGroups[this.itemGroups.length - 1]).subscribe(newGroup => {
      this.itemGroups[this.itemGroups.length - 1].id = newGroup.id
    })
  }

  addNewItem(index, table: Table) {
    this.itemGroups[index].items.push({
      name: 'New Item',
      version: 0,
      pricePerItem: 0,
      pricePerItemInstall: 0
    })
    timer(1).subscribe(emit => {
      const tables = (this.el.nativeElement).getElementsByClassName('item-editor-table');
      const fTable = tables[index];
      const cellElems = fTable.getElementsByClassName('name-cell')
      const elem = cellElems[cellElems.length - 1] as HTMLElement
      elem.click()

      const lastItemIndex = this.itemGroups[index].items.length - 1;
      this.adminPanelService.updateGroupItems(this.itemGroups[index]).subscribe(newGroup => {
        this.itemGroups[index].items[lastItemIndex].id = newGroup.items[lastItemIndex].id
      })
    })

  }

  changesMade(index: number) {
    this.updateItemsSubj.next(index)
  }

  startEdit() {
    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if (tempInputs) {
      timer(1).subscribe(() => {
        const lastInput = tempInputs[0] as HTMLInputElement
        lastInput.focus()
        lastInput.setSelectionRange(0, lastInput.value.length);
      })
    }
  }

  onEditComplete(event, index) {
    this.updateItemsSubj.next(index)
  }

  deleteLine(groupIndex: number, indexToDelete: number) {
    const tempDeleteItem = this.itemGroups[groupIndex].items[indexToDelete];

    this.adminPanelService.deleteItem(
      this.itemGroups[groupIndex].id,
      this.itemGroups[groupIndex].items[indexToDelete].id).subscribe(() => {
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.itemGroups[groupIndex].items.splice(indexToDelete, 0, tempDeleteItem)
    })
    this.itemGroups[groupIndex].items.splice(indexToDelete, 1);

  }


  openFiles(groupIndex: number, itemIndex: number) {
    const dialogRef = this.dialog.open(MiscItemFilesDialogComponent, {
      data: {
        misc: this.itemGroups[groupIndex].items[itemIndex]
      },
      panelClass: 'misc-item-files-dialog'
    });

    dialogRef.afterClosed().subscribe(newMod => {
      // if (newMod && newMod instanceof PricingCategory) {
      //   this.categoriesWithTitle[index].categories[jindex] = newMod
      // } else if (newMod === 'delete') {
      //   this.categoriesWithTitle[index].categories.splice(jindex, 1);
      // }
    })
  }


  deleteGroup(groupIndex: number) {


    this.confirmationService.confirm({
      header: `Delete group?`,
      message: `Delete ${this.itemGroups[groupIndex].name} group?`,
      accept: () => {
        this.adminPanelService.deleteGroup(this.itemGroups[groupIndex].id).subscribe(() => {

        })

        this.itemGroups.splice(groupIndex, 1);
      },
      reject: () => {

      }
    });

  }

}
